<template>
  <v-flex v-if="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>
      <!-- <Spinner ref="spinner"></Spinner> -->
      <div class="mb-4">
        <zigZag></zigZag>
      </div>
      <v-layout text-xs-center mt-5>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-start row mx-3 mt-0 align-center>
            <v-flex>
              <v-layout row>
                <v-icon class="mr-2">fa-plus-circle</v-icon>
                <div
                  class="text-xs-left"
                  style="font-size: 20px; font-weight: 600;"
                >{{formType=='new'?"Create New":"Edit"}} Record for Batch {{record.batchId}} - {{formType=='edit'?"Doc "+ record.documentId +" - ":""}} {{record.typeId == "CA" ? "PAYMENT": "ADJUSTMENT"}}</div>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row>
                <v-flex>
                  <v-layout class="buttons mb-0 mr-0" justify-end row>
                    <v-btn icon @click="cancel" class="pa-0 mr-0">
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-flex mb-3 xs12 mx-2>
            <v-form v-model="valid" @submit="createBatchRecord" ref="createBatchRecordForm">
              <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                <v-layout hide-details justify-start row mt-0 mb-0>
                  <v-flex xs2 mr-4>
                    <v-menu
                      v-model="date"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        class="align-center"
                        slot="activator"
                        v-model="record.date"
                        label="Date*"
                        prepend-inner-icon="fa-calendar-alt"
                        readonly
                        single-line
                        :rules="requiredRules"
                      ></v-text-field>
                      <v-date-picker v-model="record.date" @input="date = false" :max="currentDate"></v-date-picker>
                    </v-menu>
                  </v-flex>

                  <v-flex hide-details mx-4 xs3>
                    <v-autocomplete
                      :items="ddlAccounts"
                      v-model="record.BAN"
                      item-text="Text"
                      item-value="Value"
                      label="Account*"
                      required
                      :rules="requiredRules"
                      tabindex="0"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex hide-details mx-4 xs2 v-if="record.typeId !== 'CA'">
                    <v-autocomplete
                      :items="ddlBatchRecordType"
                      v-model="record.docTypeId"
                      item-text="Text"
                      item-value="Value"
                      label="Type*"
                      required
                      :rules="requiredRules"
                      tabindex="1"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex mx-4 xs3>
                    <v-text-field
                      v-model="record.reference"
                      label="Reference*"
                      :rules="requiredRules"
                      maxlength="40"
                      tabindex="2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex mx-4 xs2>
                    <v-text-field
                      v-model="record.amount"
                      label="Amount*"
                      prefix="$"
                      :rules="amountRules"
                      tabindex="3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex mx-4 xs1>
                    <v-btn
                      color="success"
                      @click="createBatchRecord"
                      class="ml-2 mr-4"
                      v-if="formType=='new'"
                      tabindex="4"
                    >Create New</v-btn>
                    <v-btn
                      color="success"
                      @click="editBatchRecord"
                      class="ml-2 mr-4"
                      v-if="formType=='edit'"
                      tabindex="4"
                    >Update Record</v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-form>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import Spinner from "../../components/Spinner.vue";
import axios from "axios";
import Bus from "../../bus";
import moment from "moment";
import zigZag from "../../components/ZigZag";

export default {
  name: "Create Batch Record",

  components: {
    Spinner,
    zigZag
  },

  data: () => ({
    dialog: false,
    valid: true,
    ddlAccounts: [],
    isBatchDescriptionDisabled: false,

    formType: null,

    resolve: null,
    reject: null,
    record: {},
    date: false,
    ddlBatchRecordType: [],

    requiredRules: [v => !!v || "Required"],
    amountRules: [
      v => !!v || "Required",
      v =>
        new RegExp("^\\d+(?:\\.\\d{0,2})?$").test(v) ||
        "Must be in currency format"
    ],
  }),
  computed: {
    currentDate() {
      return moment()
        .format("YYYY-MM-DD")
        .toString();
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      // this.getDropdownOptions("api/Account/GetEditAccountDdls", "ddlAccountTypes")
    },

    // Get data for elements in component from response data props
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    // Get data for props of elements
    async getPropData(url, obj, prop) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`][`${prop}`] = resp.data))
        .catch(err => console.log(err));
    },

    // Get data for elements in component from response data
    async getResponseData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },
    async open(item) {
      this.record = await Object.assign({}, item);
      this.formType = "new";
      this.dialog = true;
      this.getDropDownLists();
    },
    async openEdit(item) {
      this.record = await Object.assign({}, item);
      this.formType = "edit";
      this.getDropDownLists();
      this.dialog = true;
    },
    async getDropDownLists() {
      this.getResponseData("api/Account/GetAllAccountsDDL/", "ddlAccounts");
      if (this.record.typeId !== "CA") {
        this.getElementData(
          "api/Receivables/GetCreateBatchRecordDLL/",
          "ddlBatchRecordType"
        );
      }
    },
    async createBatchRecord() {
      if (this.$refs.createBatchRecordForm.validate()) {
        var batchId = this.record.batchId;
        var typeId = this.record.typeId;
        var type = this.record.type;
        var date = this.record.date;
        if (typeId == "CA"){
          this.record.docTypeId = typeId
        }
        var result = await axios
          .post("api/Receivables/CreateBatchRecord", this.record)
          .then(res => {
            this.record = { batchId: batchId, typeId: typeId, type: type, date:date };
            Bus.$emit("alert", {
              color: "success",
              message: "New Batch Record Created Successfully"
            });
            this.$root.$emit("initialize", this.initialize);
            this.$emit("parentRefresh");
          });
      }
    },
    async editBatchRecord() {
      if (this.$refs.createBatchRecordForm.validate()) {
        var batchId = this.record.batchId;
        var typeId = this.record.typeId;
        var type = this.record.type;
        var result = await axios
          .post(
            "api/Receivables/EditBatchRecord/" + this.record.documentId,
            this.record
          )
          .then(res => {
            //   this.record = {batchId: batchId, typeId:typeId, type: type}
            // this.formType="new"
            Bus.$emit("alert", {
              color: "success",
              message: "Batch Record Updated Successfully"
            });
            this.close();
            this.$root.$emit("initialize", this.initialize);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    cancel() {
      (this.record = {}), (this.dialog = false);
      // this.resolve(false)
      // this.resetFormFilters()
      this.$emit("parentInitSelectedRow");
    },
    close() {
      (this.record = {}), (this.dialog = false);
      // this.resolve(item)
      // this.$root.$emit("initialize", this.initialize);
      this.$emit("parentRefresh");
    },
    isOpen() {
      return this.dialog;
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  }
};
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

